export default "__VITE_ASSET__MHwQXRKz__"